<template>
  <div class="performanceResult">
    <topmytitle title1=" 绩效考核结果查询" />
    <div class="select">
      <van-field
        class="year"
        readonly
        clickable
        :value="year"
        label="年度选择"
        placeholder="点击选择年份"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :default-index="year - 1990 - 1"
          title="选择年份"
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
        <!-- <van-datetime-picker
          type="year"
          v-model="currentDate"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        /> -->
      </van-popup>
    </div>
    <div class="resultTable">
      <el-table :data="tableData" height="100%">
        <el-table-column prop="PERIOD" label="时间说明" width="80">
        </el-table-column>
        <el-table-column
          prop="C_PERF_LEVEL"
          label="绩效等级"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="C_EVALUATE_DESCR" label="评价">
        </el-table-column>
      </el-table>
    </div>
    <loading-show :isLoadindShow="loading"></loading-show>
  </div>
</template>

<script>
  import { getPerformancet } from '../request/api';
  import topmytitle from '../components/topmytitle';
  import LoadingShow from '../components/loading';

  export default {
    name: 'performanceResult',
    components: {
      topmytitle,
      LoadingShow
    },
    data() {
      return {
        year: new Date().getFullYear() + '',
        tableData: [],
        loading: false,
        showPicker: false,
        columns: Array.from(
          { length: new Date().getFullYear() - 1990 },
          (item, index) => index + 1 + 1990 + ''
        )
        // minDate: new Date(1990, 0, 1),
        // maxDate: new Date(),
        // currentDate: new Date()
      };
    },
    mounted() {
      this.getData();
    },
    methods: {
      onConfirm(time) {
        this.year = new Date(time).getFullYear() + '';
        this.showPicker = false;
        this.getData();
      },
      getData() {
        this.loading = true;
        let params = {
          EMPLID: sessionStorage.getItem('EMPLID'),
          C_YEAR: this.year
        };
        getPerformancet(params)
          .then(res => {
            this.tableData = res.DATA || [];
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  };
</script>

<style lang="less" scoped>
  .performanceResult {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
  .select {
    background-color: #fff;
    padding: 10px;
    /deep/.year .van-cell__value .van-field__body:before {
      display: inline-block;
      content: '';
      position: relative;
      top: 2px;
      left: 60px;
      width: 0;
      height: 0;
      border: 5px solid transparent;
      border-top-color: #999;
    }
  }
  .resultTable {
    padding: 10px;
    flex: 1;
    background-color: #fff;
    overflow: auto;
  }
</style>
